// Isotipo de Venuz (la Z y la V en espacio negativo), del libro de marca «Venuz Brandbook» del Drive.
export function IsotipoVenuz({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 144 144" className={className} aria-hidden focusable="false">
      <path d="M54 22.5H0V112.5L54 22.5Z" fill="#F0B90B" />
      <path d="M86.3045 0L18 121.5H66.0419L135 0H86.3045Z" fill="#F0B90B" />
      <path d="M144 18L72 144H144V18Z" fill="#F0B90B" />
    </svg>
  );
}
